import { render, staticRenderFns } from "./_Breakfast.vue?vue&type=template&id=ebb86a64"
import script from "./_Breakfast.vue?vue&type=script&lang=js"
export * from "./_Breakfast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports